module.exports = __webpack_public_path__ + "static/media/1.22_preview.f3c232f6.png";